<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        大连市副市长张志宏一行到海大智龙考察
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-06-22</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
        <p class="indentation">
         2020年6月19日下午，大连市副市长张志宏、市科技局副局长赵宏志等领导莅临海大智龙公司，对我司科技创新及成果转化工作进行考察指导。
        </p>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news21/01.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <p class="indentation">
         我司董事长尹勇教授对市领导的到访表示热烈欢迎，并陪同市领导参观了我司的智能产品和VR/AR产品，包括船载智能导航仪、智能配载仪、智能船桥系统、虚拟海战系统、VR/AR产品、航海模拟器及游艇模拟器等。
        </p>
        <p class="indentation">
        座谈交流期间，尹勇董事长着重向市领导介绍了公司2020年获得的大连市重大科技成果转化专项“高品质航海模拟器及智能化船用产品”项目的进展情况及取得的阶段性成果。市领导对我司科技成果转化项目给予了肯定，希望海大智龙在产品化方面加快步伐，期待着海大智龙在科技成果转化和公司化运营方面提供一个成功的范例。尹勇表示市领导莅临我司指导是对公司工作的认可和支持，未来公司将在科技创新、人才储备等方面持续加大研发投入，早出产品，争取在船用智能化产品领域占有一席之地。 </p>
    
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news21/02.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news21/03.png" />
          </div>
        </div>
      </div>
  <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news21/04.png" />
          </div>
        </div>
      </div>
        <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news21/05.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  img {
    vertical-align: middle;
    border-style: none;
    width: 95%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news21.vue